class CkeditorEveryone extends HTMLTextAreaElement {
  connectedCallback () {
    const self = this
    const contenidoId = this.getAttribute('contenido_id')

    CKEDITOR.replace(self, {
      on: {
        instanceReady: function () {
          this.dataProcessor.writer.setRules('strong', {
            indent: true,
            breakBeforeOpen: true,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false
          })
          this.dataProcessor.writer.setRules('a', {
            indent: true,
            breakBeforeOpen: true,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false
          })
        }
      },
      allowedContent: this.isAdmin(),
      language: 'es',
      disableNativeSpellChecker: false,
      entities: false,
      height: (this.rows > 2 ? this.rows : 20) * 30,
      toolbar: [
        this.isAdmin() ?
          ['Bold', 'Italic', 'Blockquote', 'RemoveFormat'] :
          ['Bold', 'Italic', 'Blockquote'],
        ['Image', 'Link', 'Unlink'],
        ['Undo', 'Redo'],
        ['NumberedList', 'BulletedList'],
        ['Source']
      ],
      filebrowserImageUploadUrl: this.urlDeSubida(contenidoId)
    })

    CKEDITOR.on('dialogDefinition', function (ev) {
      if (ev.data.name === 'image') {
        var dialog = ev.data.definition
        var oldOnShow = dialog.onShow
        var infoTab = dialog.getContents('info')

        infoTab.remove('ratioLock')
        infoTab.remove('txtHeight')

        dialog.onShow = function () {
          oldOnShow.apply(this, arguments)
          this.selectPage('Upload')
        }
      }
    })
  }

  // La pestaña «Subir» de CKEditor 4 envía un formulario a un iframe, sin cabeceras ni el token de Rails:
  // el token CSRF de la página viaja en la URL o Rails atiende la subida sin sesión (TDT-RNK-7114).
  urlDeSubida (contenidoId) {
    const parametros = new URLSearchParams({ contenido_id: contenidoId })
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (token) parametros.set('authenticity_token', token)

    return `/fotos/create_ckeditor?${parametros}`
  }

  isAdmin () {
    return 'true' === this.getAttribute('admin')
  }
}

export default CkeditorEveryone
